import styled from "@emotion/styled";
import {CSSProperties} from "react";

/** ページ全体を縦に並べるコンテナ */
export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 16px;
`;
/** ヘッダー部分：2 列のグリッドレイアウト */
export const HeaderGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    column-gap: 24px;
`;
/** 左側：複数の FormField を縦に並べるコンテナ */
export const FieldsColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

/** 右側：アクションボタンを下端揃えで横に並べるコンテナ */
export const ActionsColumn = styled.div`
    display: flex;
    gap: 14px;
    align-self: end; /* Grid コンテナ内で下端揃えにする */
`;

export const LabelField = styled.div`
    display: flex;
    gap: 16px;
    > label {
        margin-bottom: 0;
    }
    > span:last-child {
        font-weight: bold;
        align-items: center;
    }
`;

/** FormField 内の <input class="bp3-input" .../> にだけ幅を指定 */
export const InputWidthWrapper = styled.div<{width?: number}>`
    & .bp3-input {
        max-width: ${({width = 180}) => `${width}px`};
        min-width: 180px;
    }
`;

export const DisplayFlexSpaceBetween = styled.div`
    display: flex;
    justify-content: space-between;
`;

type StyleProps = {
    sx?: CSSProperties;
};

type FlexGapContainerProps = StyleProps & {
    gap?: number;
};

export const FlexGapContainer = styled.div<FlexGapContainerProps>(({gap = 10, sx}) => ({
    display: "flex",
    gap: `${gap}px`,
    ...sx,
}));

export const Div = styled.div<StyleProps>(({sx}) => ({
    ...sx,
}));
